import * as z from "zod";
import {
  AVATAR_KEY_REGEX,
  AVATAR_MEDIA_TYPES,
  assertAvatarPayload,
} from "../avatarPolicy";
import { mutator } from "./mutator";

export const setCustomAvatarSchema = z.object({
  key: z.string().regex(AVATAR_KEY_REGEX),
  mediaType: z.enum(AVATAR_MEDIA_TYPES),
  data: z.string(),
});

export const setCustomAvatar = mutator({
  redactKeys: ["data"],
  schema: setCustomAvatarSchema,
  resolve: {},
  permissions: { none: "updates only the calling user’s own avatar" },
  fn: async ({ tx, ctx, args }) => {
    assertAvatarPayload({ data: args.data, mediaType: args.mediaType });
    // Skip the optimistic local update — until the server has written the file,
    // any Avatar that picks up the new key would 404 and stick in a broken state.
    if (tx.location !== "server") return;
    await tx.mutate.user.update({
      id: ctx.userId,
      customAvatarKey: args.key,
    });
  },
});
